import create from 'zustand';
import {PackingSlipStatusResponse} from '../types/packingSlipStatusResponse';
import filterCanceledPackingSlips from '../helpers/filters/filterCanceledPackingSlips';
import convertPackingSlipToShipment from '../helpers/converters/convertPackingSlipToShipment';
import {Shipment} from '../models/shipment';
import {api, apiUrlBuilder} from '../utils/api';
import {AuthError} from '../errors/authError';
import {AuthErrorTypeEnum} from './authStore';
import AbortAddon from 'wretch/addons/abort';

export interface ShipmentsStore {
    fetchShipments: (
        bearer: string,
        abortController?: AbortController
    ) => Promise<void>;
    shipments: Array<Shipment> | null;
    delayMessage: string;
}

export const useShipmentsStore = create<ShipmentsStore>()((set, get) => ({
    delayMessage: '',
    shipments: null,
    fetchShipments: async (
        bearer: string,
        abortController?: AbortController
    ): Promise<void> => {
        const response = await api
            .addon(AbortAddon())
            .signal(abortController ?? new AbortController())
            .url(apiUrlBuilder('/zo-geregeld/shipping'))
            .headers({
                Authorization: `Bearer ${bearer}`,
            })
            .get()
            .unauthorized(res => {
                throw new AuthError(AuthErrorTypeEnum.NotFound);
            })
            .badRequest(res => {
                throw new AuthError(AuthErrorTypeEnum.InputError);
            })
            .error(429, () => {
                throw new AuthError(AuthErrorTypeEnum.ToManyAttempts);
            })
            .internalError(res => {
                throw new AuthError(AuthErrorTypeEnum.Error);
            })
            .json(data => {
                return data as unknown as PackingSlipStatusResponse;
            });

        set({
            shipments: (response ?? [])
                .filter(filterCanceledPackingSlips)
                .map(packingSlip => convertPackingSlipToShipment(packingSlip)),
            delayMessage:
                "Je bestelling heeft helaas vertraging opgelopen bij de transporteur. Heb je na een paar werkdagen nog steeds niks ontvangen? Klik dan op 'hulp nodig'.",
        });
    },
}));
